module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_troendelag_pos.509322e7.pdf";